import type { QueryKey } from '@tanstack/react-query';

import { useCageController_Overview } from '@/services/hooks';

import type { UseGetCageOverviewParams } from './overview.types';

/** Same window the shared QueryClient uses, and the one `useGetCageOverview` sets. */
export const CAGE_OVERVIEW_STALE_TIME_MS = 5 * 60 * 1000;

/**
 * The overview request, in the shape `useGetCageOverview` sends.
 *
 * `from`, `to` and `daypartTag` are always present, even when undefined, so a
 * cage with no range keeps one key. `fishGroupId` is added only when set:
 * a cage-scoped request must not grow a new key.
 */
export function cageOverviewQueryParams(params: UseGetCageOverviewParams): {
    from?: string;
    to?: string;
    daypartTag?: string;
    fishGroupId?: number;
} {
    return {
        from: params.from,
        to: params.to,
        daypartTag: params.daypartTag,
        ...(params.fishGroupId != null ? { fishGroupId: params.fishGroupId } : {}),
    };
}

/** The react-query key `useCageController_Overview` builds for these params. */
export function cageOverviewQueryKey(cageId: number, params: UseGetCageOverviewParams): QueryKey {
    return useCageController_Overview.info(cageId, cageOverviewQueryParams(params)).key;
}
